import React from 'react'
import { Layout } from 'antd'
import { useLocation } from 'react-router-dom'
import styled from '@emotion/styled'
import { shouldHideLayoutElements } from './utils/features'

const { Content } = Layout

interface Props {
  children: React.ReactNode
}

const LayoutContent = ({ children }: Props) => {
  const location = useLocation()

  const display = shouldHideLayoutElements(location.pathname)

  const fullView = location.pathname.match('designer|help-centre')

  const isAppStore = location?.pathname?.includes('/mobile-app/app-store')
  const isDesigner = location?.pathname?.includes('/designer')

  return (
    <StyledContent
      className={`${
        (window.location.pathname === '/' ||
          window.location.pathname === '/heat-map') &&
        '-dashboard'
      }`}
      style={{
        padding: fullView ? '0' : 24,
        overflow: fullView ? 'hidden' : 'auto',
        display: 'inline-block',
        background: `${
          display || location?.pathname === '/' ? 'transparent' : '#fff'
        }`,
        paddingTop: display || isDesigner ? '0' : '24px',
        marginBottom: isAppStore ? '0' : '24px'
      }}
    >
      {children}
    </StyledContent>
  )
}

const StyledContent = styled(Content)`
  margin: 24px;
  overflow-anchor: none;
  width: auto;
  border-radius: 4px;

  &.-dashboard {
    background: transparent;
    padding: 0 !important;
  }
`

export default LayoutContent
